// Centralized, admin-editable site images (OG + hero backgrounds) for the
// Orthocare / Gestos Ágeis family of domains. Values are stored in the
// Settings entity (key = setting_key, value = image URL) so they can be
// edited from the /og-preview page and consumed everywhere.

export const SITE_IMAGE_KEYS = {
  ogOrthocare: 'site_image_og_orthocare_pt',
  ogGestos: 'site_image_og_gestosageis_pt',
  heroOrthocarePt: 'site_image_hero_orthocare_pt',
  heroOrthocarerentPt: 'site_image_hero_orthocarerent_pt',
  heroOrthocarerentCom: 'site_image_hero_orthocarerent_com',
};

export const SITE_IMAGE_DEFAULTS = {
  site_image_og_orthocare_pt:
    'https://media.base44.com/images/public/691220492173ae6cbe68ab07/05c0ac79d_Screenshot_20260425_214044_Google.jpg',
  site_image_og_gestosageis_pt:
    'https://media.base44.com/images/public/691220492173ae6cbe68ab07/26b037cd1_generated_image.png',
  site_image_hero_orthocare_pt:
    'https://media.base44.com/images/public/691220492173ae6cbe68ab07/05c0ac79d_Screenshot_20260425_214044_Google.jpg',
  site_image_hero_orthocarerent_pt:
    'https://media.base44.com/images/public/691220492173ae6cbe68ab07/bdbc15040_generated_image.png',
  site_image_hero_orthocarerent_com:
    'https://media.base44.com/images/public/691220492173ae6cbe68ab07/1274206ba_generated_image.png',
};

export const getSiteImage = (settings, key) => {
  const found = Array.isArray(settings) ? settings.find((s) => s.setting_key === key) : null;
  return (found && found.setting_value) || SITE_IMAGE_DEFAULTS[key];
};

// Pick the right hero background for the current orthocare domain, reading
// the override from Settings (falls back to the per-domain default).
export const getHeroImageForOrthocareDomain = (settings) => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host.endsWith('orthocarerent.com')) return getSiteImage(settings, SITE_IMAGE_KEYS.heroOrthocarerentCom);
  if (host === 'orthocarerent.pt') return getSiteImage(settings, SITE_IMAGE_KEYS.heroOrthocarerentPt);
  return getSiteImage(settings, SITE_IMAGE_KEYS.heroOrthocarePt);
};